var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocuments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4677 4.42247V5H13V4.42247H12.4677ZM3.29237 5H12.4677V3.84493H3.29237V5ZM13 4.42247V3.11802H11.9355V4.42247H13ZM10.7724 1.02168L3.1096 2.20948L3.26015 3.35294L10.9229 2.16514L10.7724 1.02168ZM3.1096 2.20948C2.47291 2.30817 2 2.89984 2 3.59769H3.06452C3.06452 3.47465 3.1479 3.37034 3.26015 3.35294L3.1096 2.20948ZM13 3.11802C13 1.82934 11.9481 0.839434 10.7724 1.02168L10.9229 2.16514C11.4574 2.0823 11.9355 2.53226 11.9355 3.11802H13ZM3.29237 3.84493C3.16653 3.84493 3.06452 3.73424 3.06452 3.59769H2C2 4.37217 2.57861 5 3.29237 5V3.84493Z",
    fill: "#1C274D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 9H11",
    stroke: "#1C274D",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 11H10",
    stroke: "#1C274D",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3 4.70588V13.8824C3 15.0519 3.92342 16 5.0625 16H11.9375C13.0766 16 14 15.0519 14 13.8824V10.3529M3 4.70588V4M3 4.70588H11.9375C13.0766 4.70588 14 5.65399 14 6.82353V7.52941",
    stroke: "#1C274D",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocuments);
export default __webpack_public_path__ + "static/media/Documents.1f7ef9f44e520e37fd9043389250cacb.svg";
export { ForwardRef as ReactComponent };